import { HEALTH_LABEL, STATUS_LABEL, TARIFF_LABEL, TICKET_STATUS_LABEL, type Health, type Tariff, type TicketStatus, type WorkshopRow, type WorkshopStatus } from "../api";

export function TariffBadge({ tariff }: { tariff: Tariff }) {
  // Diqqat: bu zanjir noma'lum tarif uchun "yellow"ga (sinov rangiga) tushadi —
  // shuning uchun har bir tarif aniq ko'rsatilgan bo'lishi kerak.
  const tone =
    tariff === "max" || tariff === "pro"
      ? "purple"
      : tariff === "comfort"
        ? "blue"
        : tariff === "standard"
          ? "green"
          : "yellow";
  return <span className={`badge ${tone}`}>{TARIFF_LABEL[tariff]}</span>;
}

export function StatusBadge({ ws }: { ws: Pick<WorkshopRow, "tariff" | "status" | "is_expired"> }) {
  if (ws.status === "archived") return <span className="badge gray">Arxivlangan</span>;
  if (ws.is_expired || ws.status === "expired") return <span className="badge red">Muddati tugagan</span>;
  if (ws.status === "suspended") return <span className="badge yellow">To'xtatilgan</span>;
  if (ws.tariff === "trial") return <span className="badge yellow">Sinov</span>;
  if (ws.status === "active") return <span className="badge green">Faol</span>;
  return <span className="badge gray">{STATUS_LABEL[ws.status as WorkshopStatus] ?? ws.status}</span>;
}

export function HealthBadge({ health, reason }: { health: Health; reason?: string }) {
  const tone = health === "green" ? "green" : health === "yellow" ? "yellow" : "red";
  return (
    <span className={`badge ${tone}`} title={reason}>
      <span className="health-dot" aria-hidden /> {HEALTH_LABEL[health]}
    </span>
  );
}

export function CodeUsedBadge({ used }: { used: boolean }) {
  return used
    ? <span className="badge gray">Foydalanilgan</span>
    : <span className="badge green">Yangi</span>;
}

export function TicketStatusBadge({ status }: { status: TicketStatus }) {
  const tone = status === "replied" ? "green" : status === "seen" ? "blue" : "gray";
  return <span className={`badge ${tone}`}>{TICKET_STATUS_LABEL[status]}</span>;
}
